import React, { useEffect, useState } from "react";
import { acceptCall, declineCall, hangUp, phaseLabel, toggleMute, useCall } from "./calls";
import { errText, t } from "./i18n";
import { Avatar, Button, cx } from "./ui";

/** Floating call card. Sits in a corner so it never covers the game board. */
export function CallBar() {
  const c = useCall();
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    if (!c || c.phase !== "active" || !c.startedAt) return setElapsed(0);
    const tick = () => setElapsed(Math.floor((Date.now() - c.startedAt!) / 1000));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [c?.phase, c?.startedAt]);
  if (!c) return null;
  const mm = String(Math.floor(elapsed / 60)).padStart(2, "0");
  const ss = String(elapsed % 60).padStart(2, "0");
  const incoming = c.phase === "incoming";
  const ringing = c.phase === "calling" || c.phase === "ringing";
  const live = c.phase === "connecting" || c.phase === "active" || c.phase === "reconnecting";
  return (
    <aside
      className={cx("callbar", `callbar-${c.phase}`)}
      role="dialog"
      aria-label={t.callTitle}
      aria-live="assertive"
    >
      <div className="callbar-who">
        <Avatar name={c.peer.displayName} url={c.peer.avatarUrl} size={44} />
        <div className="grow">
          <strong>{c.peer.displayName}</strong>
          <div className="small">
            {phaseLabel(c, t as any)}
            {c.phase === "active" && <span dir="ltr"> · {mm}:{ss}</span>}
          </div>
          {live && <div className="small muted">{c.muted ? t.micOff : t.micOn}{c.peerMuted ? ` · ${t.peerMuted}` : ""}</div>}
          {c.error && <div className="small callbar-error">{errText({ code: c.error })}{c.error === "mic_permission_denied" && <> — {t.micPermissionHelp}</>}</div>}
          {c.phase === "ended" && <div className="small muted">{t.callNotRecorded}</div>}
        </div>
      </div>
      <div className="callbar-actions">
        {incoming && (
          <>
            <Button onClick={() => void acceptCall()}>{t.acceptCall}</Button>
            <Button kind="danger" onClick={declineCall}>{t.declineCall}</Button>
          </>
        )}
        {ringing && <Button kind="danger" onClick={hangUp}>{t.cancelCall}</Button>}
        {live && (
          <>
            <Button kind="ghost" onClick={toggleMute} aria-pressed={c.muted}>{c.muted ? t.micUnmute : t.micMute}</Button>
            <Button kind="danger" onClick={hangUp}>{t.endCall}</Button>
          </>
        )}
      </div>
    </aside>
  );
}
